const transientVarNames: Set<string> = new Set<string>();

export const addTransientVarName = (k: string): void => {
  transientVarNames.add(k);
};

// don't save them
export const isGameVarTransient = (key: string): boolean => transientVarNames.has(key);
